export default __webpack_public_path__ + "static/media/refectori-espleni-cover.87d5679c.jpg";